import React, { useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { capitalize } from '../utils/usefulFunctions';
import useTranslate from '../customHooks/useTranslate';

const getLabelKey = (arrayOptions, key) => {
    return arrayOptions.map(opt => {
        return { ...opt, label: opt[key] || opt.Caption || opt.Name };
    });
};

const EmptyTypeahead = props => {
    const {
        labelText,
        options = [],
        optionsLabelKey = 'label',
        handleChange,
        id,
        errorMessage,
        infoMessage,
        required,
        idValue,
        value,
        inputValue = '',
        setInputValue = () => {},
        noOptionsText = 'No options',
        ...TypeaheadProps
    } = props;
    const translate = useTranslate();
    const label = capitalize(translate(labelText));
    const [optionsTypeahead, setOptionstypeahead] = useState(
        getLabelKey(options, optionsLabelKey)
    );

    useEffect(() => {
        const newOptions = getLabelKey(options, optionsLabelKey);
        setOptionstypeahead(newOptions);
    }, [options, optionsLabelKey]);

    const handleFilter = typeaheadOptions => {
        return typeaheadOptions.filter(op => {
            return op.label.toLowerCase().includes(inputValue.toLowerCase());
        });
    };

    return (
        <Stack width={'100%'}>
            <Autocomplete
                disablePortal
                id={label}
                options={optionsTypeahead}
                sx={{ width: '100%' }}
                renderInput={params => (
                    <TextField
                        {...params}
                        label={label}
                        size='small'
                        error={!!errorMessage}
                        required={required}
                    />
                )}
                onChange={(e, newValue) => {
                    e.target.name = id;
                    e.target.value = newValue ? parseInt(newValue?.Id) : null;
                    handleChange(e, newValue);
                }}
                inputValue={inputValue}
                onInputChange={(e, newInputValue) => {
                    setInputValue(newInputValue);
                }}
                noOptionsText={translate(noOptionsText)}
                filterOptions={handleFilter}
                value={
                    value
                        ? value
                        : optionsTypeahead.find(
                              opt => parseInt(opt.Id) === parseInt(idValue)
                          ) || null
                }
                {...TypeaheadProps}
            />
            {errorMessage && (
                <p className='input__error-message'>
                    {translate(errorMessage)}
                </p>
            )}
            {infoMessage && (
                <p className='input__info-message'>
                    ⓘ {translate(infoMessage)}
                </p>
            )}
        </Stack>
    );
};

export default EmptyTypeahead;
